export const SET_STORAGE_TYPE_ACT_BY_COMPANY = 'SET_STORAGE_TYPE_ACT_BY_COMPANY';
export const SET_STORAGE_TYPE_BY_COMPANY = 'SET_STORAGE_TYPE_BY_COMPANY';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
